import type { ICellRendererParams } from "ag-grid-community";
import { Loader2 } from "lucide-react";

import type { TraceGridRow } from "./types";

import { normalizeToRequestLogStatus } from "@/components/StructuredSearch/config/filter-value-type-behavior";
import { Badge, BadgeSize, BadgeVariant } from "@/components/ui/Badge";
import { RequestStatusBadge } from "@/components/ui/RequestStatusBadge";

export const TraceStatusCellRenderer = ({ data }: ICellRendererParams<TraceGridRow>) => {
  if (!data) {
    return null;
  }

  const isRunning = data.end === null;
  if (isRunning) {
    return (
      <Badge variant={BadgeVariant.BLUE} size={BadgeSize.SM}>
        <Loader2 className="h-3 w-3 animate-spin" />
        Running
      </Badge>
    );
  }

  const status = data.status ? normalizeToRequestLogStatus(String(data.status)) : null;
  if (!status) {
    return <span className="text-gray-400">-</span>;
  }

  return <RequestStatusBadge status={status} size={BadgeSize.SM} />;
};

export default TraceStatusCellRenderer;
